import script from "./AssetsChart.vue?vue&type=script&setup=true&lang=ts"
export * from "./AssetsChart.vue?vue&type=script&setup=true&lang=ts"

import "./AssetsChart.vue?vue&type=style&index=0&id=3bb18828&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb18828"]])

export default __exports__